"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18n = require("i18n-js");
var React = require("react");
var errorImageSrc = require("../../../images/top-level/500.svg");
function ErrorDisplay(props) {
    if (props.hide) {
        return null;
    }
    return (React.createElement("div", { className: "error mb-1 align-center" },
        React.createElement("img", { src: errorImageSrc, alt: I18n.t('discovery.errorAltText') }),
        React.createElement("h3", { className: "heading-3 normal mt-2" }, I18n.t('discovery.errorDisplay.message'))));
}
exports.default = ErrorDisplay;
//# sourceMappingURL=error_display.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/error_display.js
// module id = xTc5
// module chunks = 20 21 22